module.exports = __webpack_public_path__ + "static/media/news-doctor.33fa4c91.jpg";